<template>
    <div>
    <CRUDCriteria :showReset="true" :showSearch="false">
        <template v-slot:criteriaRows>
            <div class="mt-0 ml-6 mr-6 mb-0 pa-0">
            <v-row class="row">
                <v-col cols="3" class="pt-0 pb-0">
                    <CommonDropDowns
                        :isItTaxYear=true
                        @change="dataFromCommonDropDowns"
                        :criteriaState="criteriaState" />
                </v-col>
            </v-row>
        </div>
        </template>
    </CRUDCriteria>
</div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import CRUDCriteria from '../../common/base/crud-2.0/CRUDCriteria.vue';
import CommonDropDowns from '../../tax/common-utils/CommonDropDowns.mixin.vue';
import '../../../assets/style.css';

export default {
  components: {
    CRUDCriteria,
    CommonDropDowns,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'taxRollSummaryList',
    },
  },
  created() {
    this.funcToLoadOnCreated();
  },
  computed: {
    ...mapState({
      taxYearList: (state) => state.tax.taxCommon.taxYearList,
    }),
    ...mapGetters('base/crud', ['criteria']),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapActions('tax/taxCommon', ['loadTaxYearList']),
    dataFromCommonDropDowns(val, whichField) {
      this.criteriaState[whichField] = val;
      this.searchByCriteria();
    },
    searchByCriteria() {
      this.$emit('loadCRUDList');
    },
    async funcToLoadOnCreated() {
      await this.loadTaxYearList({ postProcessTrans: this.postProccessTaxYearData });
    },
  },
};
</script>
